module.exports = __webpack_public_path__ + "img/avatar-default.b21f664a.png";